<div *ngIf="messageService.messages.length">
	<h3>Messages</h3>
	<button class="clear" (click)="messageService.clear()">clear</button>
	<br>
	<ol>
		<li *ngFor='let message of messageService.messages'> {{message}} </li>
	</ol>
</div>